import { Component, ViewEncapsulation } from '@angular/core';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DispatchVendorCreditBus } from '@app/cp/shared/models/DispatchVendorCreditBus';
import { BaseGridUIComponent } from '@app/cp/shared/base-components/base-grid-ui.component';

@Component({
    selector: 'dispatch-vendor-credits',
    templateUrl: './dispatch-vendor-credits.component.html',
  styleUrls: ['./dispatch-vendor-credits.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DispatchVendorCreditsComponent extends BaseGridUIComponent<DispatchVendorCreditBus, null, DispatchesService>  {

    constructor(svc_data: DispatchesService, globals: GlobalsService) {
        super(globals);
        this.svc_data = svc_data;
    }
}
